import React from 'react';

import { DEFAULT_ERROR_MESSAGE } from '@shared/config';

import { toast } from '@shared/ui';

import ToasterSMSTrouble, { ToasterSMSTroubleMode } from './ToasterSMSTrouble';
import { TEXTS } from './texts';

const useAuthNotifications = () => ({
  userAlreadyRegisteredByPhone: () => toast.error(TEXTS.ERROR_USER_ALREADY_REGISTERED_BY_PHONE),
  userRegisteredByEmail: () => toast.error(TEXTS.ERROR_USER_REGISTERED_BY_EMAIL),
  userNotFound: () => toast.error(TEXTS.ERROR_USER_NOT_FOUND),
  userAlereadyRegisteredByEmail: () => toast.error(TEXTS.ERROR_USER_ALREADY_REGISTERED_BY_EMAIl),
  unexpectedError: () => toast.error(DEFAULT_ERROR_MESSAGE),
  registerSMSTrouble: (onSubmit: () => void) => {
    const id = toast.error(
      <ToasterSMSTrouble
        mode={ToasterSMSTroubleMode.REGISTER}
        onSubmit={onSubmit}
        onClose={() => toast.dismiss(id)}
      />,
      { duration: 0 }
    );
  },
  registerSMSCodeTrouble: (message: string) => toast.error(message),
  loginSMSTrouble: (onSubmit: () => void) => {
    const id = toast.error(
      <ToasterSMSTrouble
        mode={ToasterSMSTroubleMode.LOGIN}
        onSubmit={onSubmit}
        onClose={() => toast.dismiss(id)}
      />,
      { duration: 0 }
    );
  },
});

export default useAuthNotifications;
